/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
//# sourceMappingURL=isDate.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/util/isDate.js
// module id = fmCu
// module chunks = 0 1